import { useState, useEffect } from "react";

import { processInputValue, DetectedFileItem, isSimpleValue } from "../utils";

interface UseFileContentReturn {
  fileItems: DetectedFileItem[] | null;
  isFileContent: boolean;
  isProcessingFile: boolean;
}

export const useFileContent = (displayValue: string): UseFileContentReturn => {
  const quickCheck = isSimpleValue(displayValue);
  const [fileItems, setFileItems] = useState<DetectedFileItem[] | null>(null);
  const [isFileContent, setIsFileContent] = useState(false);
  const [isProcessingFile, setIsProcessingFile] = useState(!quickCheck || false);

  useEffect(() => {
    if (quickCheck || !displayValue || displayValue.length < 25 || displayValue?.trim() === "") {
      setIsFileContent(false);
      setFileItems(null);
      setIsProcessingFile(false);

      return;
    }

    const checkForFileContent = async () => {
      setIsProcessingFile(true);
      try {
        const [result] = await Promise.all([
          processInputValue(displayValue),
          new Promise(resolve => {
            setTimeout(resolve, 1);
          }),
        ]);
        if (result.isFileCollection && result.items && result.items.length > 0) {
          setIsFileContent(true);
          setFileItems(result.items);
        } else {
          setIsFileContent(false);
          setFileItems(null);
        }
      } catch {
        setIsFileContent(false);
        setFileItems(null);
      } finally {
        setIsProcessingFile(false);
      }
    };

    checkForFileContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayValue]);

  return {
    fileItems,
    isFileContent,
    isProcessingFile,
  };
};
